
// Uncomment to enable Bootstrap tooltips
// https://getbootstrap.com/docs/4.0/components/tooltips/#example-enable-tooltips-everywhere
// $(function () { $('[data-toggle="tooltip"]').tooltip(); });

// Uncomment to enable Bootstrap popovers
// https://getbootstrap.com/docs/4.0/components/popovers/#example-enable-popovers-everywhere
// $(function () { $('[data-toggle="popover"]').popover(); });



window.addEventListener('scroll', function(e) {

    const target = document.querySelectorAll('.js-move-on-scroll');

    var index = 0, length = target.length;
    for (index; index < length; index++) {
        var pos = window.pageYOffset * target[index].dataset.rate;

        if(target[index].dataset.direction === 'vertical') {
            target[index].style.transform = 'translate3d(0px,'+pos+'px, 0px)';
        } else {
            var posX = window.pageYOffset * target[index].dataset.ratex;
            var posY = window.pageYOffset * target[index].dataset.ratey;

            target[index].style.transform = 'translate3d('+posX+'px, '+posY+'px, 0px)';
        }
    }

});

// let burgerElement = document.getElementById('nav-toggle');

// let burgerElementClosedColor = 'rgb(0,0,0)';

// if (burgerElement.classList.contains('is-inverted')) {
//     burgerElementClosedColor = 'rgb(255,255,255)';
// }

// let burgerAnim = lottie.loadAnimation({
//   container: burgerElement, // the dom element that will contain the animation
//   renderer: 'svg',
//   loop: false,
//   autoplay: false,
//   path: 'scripts/27375-menu-burger-1.json' // the path to the animation json
// });

let map;
let mapElement = document.getElementById('map');



function initMap() {
  let dirMap = (window.location.href.indexOf("ru"))?'../scripts/map-style.json':'scripts/map-style.json';
  let url = (window.location.href.indexOf("en"))?'../images':'images';
  //$.getJSON( 'scripts/map-style.json', function( styles ) {
  $.getJSON( dirMap, function( styles ) {
    map = new google.maps.Map(mapElement, {
      center: (screen.width < 450 )? { lat: 55.754067, lng: 37.615062 } :{ lat: 55.752967, lng: 37.620862 },
      zoom: (screen.width < 450 )?14:15,
      styles: styles,
          disableDefaultUI: true
    });

    var gfd = {
    // This marker is 20 pixels wide by 32 pixels high.
    size: new google.maps.Size(81, 61),
    // The origin for this image is (0, 0).
    origin: new google.maps.Point(0, 0),
    // The anchor for this image is the base of the flagpole at (0, 32).
    anchor: new google.maps.Point(0, 40.5)
    };

    var voentorgPin = {
      url: url + '/marker.svg',
      size: new google.maps.Size(61, 61),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(40, 61),
      scaledSize: new google.maps.Size(61, 61),
    };

    var voentorgPinGrey = {
      url: url + '/marker-grey.svg',
      size: new google.maps.Size(61, 61),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(40, 61),
      scaledSize: new google.maps.Size(61, 61),
    };

    const voentorgMarker = new google.maps.Marker({
          position: {
            lat: 55.752967,
            lng: 37.605862
          },
          map,
          icon: voentorgPin,

        });
    const kremlingMarker = new google.maps.Marker({
          position: {
            lat: 55.75225571306985,
            lng: 37.61758404114528
          },
          map,
          icon: voentorgPinGrey
        });
      
    const redSquareMarker = new google.maps.Marker({
          position: {
            lat: 55.75403593899394,
            lng: 37.620784269473845
          },
          map,
          icon: voentorgPinGrey
        });
        
    const cathedralMarker = new google.maps.Marker({
          position: {
            lat: 55.752664769798066,
            lng: 37.6230546118034
          },
          map,
          icon: voentorgPinGrey
        });
        
    const bolshoigMarker = new google.maps.Marker({
          position: {
            lat: 55.76024515884801,
            lng:37.61864859830929
          },
          map,
          icon: voentorgPinGrey
        });

    const kremlinPalaceMarker = new google.maps.Marker({
          position: {
            lat: 55.75249066619101,
            lng:37.615713853977745
          },
          map,
          icon: voentorgPinGrey
        });

    const arsenyMarker = new google.maps.Marker({
          position: {
            lat:55.753912043749715,
            lng:37.603497784659254
          },
          map,
          icon: voentorgPinGrey
        });
    const pashkovMarker = new google.maps.Marker({
          position: {
            lat:55.750294294565656,
            lng:37.608249669318496
          },
          map,
          icon: voentorgPinGrey
        });
    const schusevMarker = new google.maps.Marker({
          position: {
            lat:55.75301725207693,
            lng:37.606849069318486
          },
          map,
          icon: voentorgPinGrey
        });
    const stateMuseumMarker = new google.maps.Marker({
          position: {
            lat:55.75665445288792,
            lng:37.60000009998956
          },
          map,
          icon: voentorgPinGrey
        });
    const helikonMarker = new google.maps.Marker({
          position: {
            lat:55.757555797338874,
            lng:37.600594369318486
          },
          map,
          icon: voentorgPinGrey
        });


         //Marker listener

        voentorgMarker.addListener("mouseover", (event) => {
          resetIcons();
          $("#voentorg").addClass("active-legend");
           voentorgMarker.setIcon(voentorgPin);

        });


        kremlingMarker.addListener("mouseover", (event) => {   
          resetIcons();
          $("#kremlin").addClass("active-legend");
          kremlingMarker.setIcon(voentorgPin);
        
        });


        redSquareMarker.addListener("mouseover", (event) => {
          resetIcons();
          $("#red-square").addClass("active-legend");
          redSquareMarker.setIcon(voentorgPin);
          
         
        });


        cathedralMarker.addListener("mouseover", (event) => {
          resetIcons();
          $("#basil").addClass("active-legend");
          cathedralMarker.setIcon(voentorgPin);
          
        });


        bolshoigMarker.addListener("mouseover", (event) => {  
          resetIcons();     
          $("#bolshoi").addClass("active-legend");
          bolshoigMarker.setIcon(voentorgPin);

        });

        kremlinPalaceMarker.addListener("mouseover", (event) => {  
          console.log("kremlin");
          resetIcons();     
          $("#kremlin-palace").addClass("active-legend");
          kremlinPalaceMarker.setIcon(voentorgPin);
        });
        arsenyMarker.addListener("mouseover", (event) => {  
          console.log("arsenyMarker");
          resetIcons();     
          $("#arseny").addClass("active-legend");
          arsenyMarker.setIcon(voentorgPin);
        });
        pashkovMarker.addListener("mouseover", (event) => { 
          console.log("pashkovMarker"); 
          resetIcons();     
          $("#pashkov").addClass("active-legend");
          pashkovMarker.setIcon(voentorgPin);
        });
        schusevMarker.addListener("mouseover", (event) => {  
          console.log("schusevMarker"); 
          resetIcons();     
          $("#schusev").addClass("active-legend");
          schusevMarker.setIcon(voentorgPin);
        });
        stateMuseumMarker.addListener("mouseover", (event) => {  
          console.log("stateMuseumMarker"); 
          resetIcons();     
          $("#state-museum").addClass("active-legend");
          stateMuseumMarker.setIcon(voentorgPin);
        });
        helikonMarker.addListener("mouseover", (event) => { 
          console.log("helikonMarker");  
          resetIcons();     
          $("#helikon").addClass("active-legend");
          helikonMarker.setIcon(voentorgPin);
        });


        
        //legend listener

        $('#voentorg').on('mouseenter', function() {
          resetIcons();
          $("#voentorg").addClass("active-legend");
           voentorgMarker.setIcon(voentorgPin);
           
       });

        $('#kremlin').on('mouseenter', function() {
          resetIcons();
          //checkdefault();  
          $("#kremlin").addClass("active-legend");
          kremlingMarker.setIcon(voentorgPin); 
       });

        $('#red-square').on('mouseenter', function() {
          resetIcons()
          $("#red-square").addClass("active-legend");
          redSquareMarker.setIcon(voentorgPin);
       });

        $('#basil').on('mouseenter', function() {
          resetIcons(); 
          $("#basil").addClass("active-legend");
          cathedralMarker.setIcon(voentorgPin);
       });

        $('#bolshoi').on('mouseenter', function() {
          resetIcons();
          $("#bolshoi").addClass("active-legend");
          bolshoigMarker.setIcon(voentorgPin);
       });
        $('#kremlin-palace').on('mouseenter', function() {
          resetIcons();
          $("#kremlin-palace").addClass("active-legend");
          kremlinPalaceMarker.setIcon(voentorgPin);
       });
        $('#arseny').on('mouseenter', function() {
          resetIcons();
          $("#arseny").addClass("active-legend");
          arsenyMarker.setIcon(voentorgPin);
       });
        $('#pashkov').on('mouseenter', function() {
          resetIcons();
          $("#pashkov").addClass("active-legend");
          pashkovMarker.setIcon(voentorgPin);
       });
        $('#schusev').on('mouseenter', function() {
          resetIcons();
          $("#schusev").addClass("active-legend");
          schusevMarker.setIcon(voentorgPin);
       });
        $('#state-museum').on('mouseenter', function() {
          resetIcons();
          $("#state-museum").addClass("active-legend");
          stateMuseumMarker.setIcon(voentorgPin);
       });
        $('#helikon').on('mouseenter', function() {
          resetIcons();
          $("#helikon").addClass("active-legend");
          helikonMarker.setIcon(voentorgPin);
       });




       function resetIcons(){
        $("#voentorg").removeClass("active-legend");
        $("#bolshoi").removeClass("active-legend");
        $("#basil").removeClass("active-legend");
        $("#red-square").removeClass("active-legend");
        $("#kremlin").removeClass("active-legend");
        $("#kremlin-palace").removeClass("active-legend");
        $("#arseny").removeClass("active-legend");
        $("#pashkov").removeClass("active-legend");
        $("#schusev").removeClass("active-legend");
        $("#state-museum").removeClass("active-legend");
        $("#helikon").removeClass("active-legend");

        voentorgMarker.setIcon(voentorgPinGrey);
        kremlingMarker.setIcon(voentorgPinGrey);
        redSquareMarker.setIcon(voentorgPinGrey);
        cathedralMarker.setIcon(voentorgPinGrey);
        bolshoigMarker.setIcon(voentorgPinGrey);
        kremlinPalaceMarker.setIcon(voentorgPinGrey);
        arsenyMarker.setIcon(voentorgPinGrey);
        pashkovMarker.setIcon(voentorgPinGrey);
        schusevMarker.setIcon(voentorgPinGrey);
        stateMuseumMarker.setIcon(voentorgPinGrey);
        helikonMarker.setIcon(voentorgPinGrey);
      
      }



      
  });



}



let burgerElement = document.getElementById('nav-toggle');

$( document ).ready(function() {
  if (mapElement) {
        initMap();
      }


  burgerElement.addEventListener('click', function(){
    $(this).toggleClass('open');
    $(this).toggleClass('inverted');

    burgerElement = !burgerElement;
      if(burgerElement) {
        // Close menu
        $('nav').toggleClass('animate__slideOutUp', true);
        $('nav').toggleClass('animate__slideInDown', false);
      }else {
        // Open menu
        $('nav').toggleClass('animate__slideInDown', true);
        $('nav').toggleClass('animate__slideOutUp', false);
      }
  })


  
  //equal height on image grid container
  // console.log($(".image-grid").find(".same-h").length );
  // if($(".image-grid").find(".same-h").length > 0){
  //   console.log("inside");
  //   let elementsToEqual = $(".image-grid").find(".same-h");
  //   let minHeight = 99999999;
  //   $( elementsToEqual ).each(function() {
  //     console.log("newheight: " + $( this ).css("height").replace("px",""));
  //     console.log("minheightBefore: "  + minHeight);
  //     minHeight = (minHeight <= parseFloat($( this ).css("height"))?parseFloat(minHeight.replace("px","")) :$( this ).css("height").replace("px",""));
  //     console.log("minheightAfter: " + minHeight);
  //   });

  
  //   $(elementsToEqual).height(minHeight.toFixed(2));
  // }

  if($(".to-same-height").length > 0){
    let elementsToEqual = $(".to-same-height");
    $( elementsToEqual ).each(function() {
      
      toSameHeight($(this));
    });
    
  }

  burgerColorToggle();

   $(".lang").find("." +  activeLang()).addClass("lang-active");
 
});

function activeLang(){

  let activeLang = ((window.location.href.indexOf("/en") != -1)?"en":"ru");
  return activeLang
}
function toSameHeight(elements){
  let elementsToEqual = $(elements).find(".same-h");
  let minHeight = 99999999;
  $( elementsToEqual ).each(function() {
    console.log("newheight: " + $( this ).css("height").replace("px",""));
    console.log("minheightBefore: "  + minHeight);
    minHeight = (minHeight <= parseFloat($( this ).css("height"))?parseFloat(minHeight) :parseFloat($( this ).css("height")));
    console.log("minheightAfter: " + minHeight);
  });
  $(elementsToEqual).height(minHeight.toFixed(2));
}

function burgerColorToggle() {
  gsap.registerPlugin(ScrollTrigger);
  let leaveBlack = document.querySelectorAll('.leave-black');
  let goWhite = document.querySelectorAll('.burger-white');
  let burger = document.querySelector('.burger-item');

  if(leaveBlack.length){
    leaveBlack.forEach(function(leaveBlack) {
      let height = leaveBlack.offsetHeight - 55 ;
      console.log(height);
      let st = ScrollTrigger.create({
        trigger: leaveBlack,
        start: "-55 top",
        end:  height + "px",
        onToggle: self => (self.isActive)?burger.classList.add('burger-force-black'):burger.classList.remove('burger-force-black'),
      });
    });
  }

  if(goWhite.length){
    goWhite.forEach(function(burgerWhite) {
      let height = burgerWhite.offsetHeight - 100 ;
      console.log(height);
      let st = ScrollTrigger.create({
        trigger: burgerWhite,
        start: "-55 top",
        end: height + "px",
        onToggle: self => (self.isActive)?burger.classList.add('burger-force-white'):burger.classList.remove('burger-force-white'),
      });
    });
  }

  
}